import React, { Component } from "react";
import { Row, Col, Button, Modal, Image } from "react-bootstrap";
import { appConfig } from "./../../../config";

class PatientsImage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const ImgData = this.props.ImageData ? this.props.ImageData : null;

    return (
      <div>
        <div className="userModalDiv">
          <Modal
            show={this.props.show}
            onHide={this.props.handleClose}
            animation={false}
            size="md"
            // backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header
              style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
              closeButton
            ></Modal.Header>

            <Modal.Body>
              <div style={{ textAlign: "center" }}>
                {ImgData !== null && ImgData.itemPic === "PrescriptionPic" ? (
                  <Image
                    style={{ height: "400px", width: "400px" }}
                    src={[
                      ImgData !== null
                        ? appConfig.imgServerip +
                          "/prescriptn?imgName=" +
                          ImgData.item
                        : require("../../../../src/assets/img/defaultPic.jpg")
                    ]}
                  />
                ) : null}
              </div>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}></Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

export default PatientsImage;
